import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromLocales from './locales.reducer';
import * as fromLoyalty from './loyalty.reducer';

export interface State {
  locales: fromLocales.State;
  loyalty: fromLoyalty.State;
}

export interface RootState {
  shared: State;
  homepage: any;
  modules: any;
}

export const reducers: ActionReducerMap<State> = {
  locales: fromLocales.reducer,
  loyalty: fromLoyalty.reducer,
};

export const localesState = (state: any | State) => state.locales;

export const rootStateSelector = createFeatureSelector<any>('homepage');
export const sharedLoyaltyState = createSelector(
  rootStateSelector,
  (state: any) => {
    return {
      "loyaltyConfig": {
        enabled_for_market: state.modules.configs.loyalty.enabled_for_market,
        enabled_for_account: state.customer.customerConfig.loyalty_enabled_for_account
      },
      "isLoading": state.modules.isLoading
    }
  }
);
